// extracted by mini-css-extract-plugin
export var blue = "_36-g";
export var brand = "_36-c";
export var darkGrey = "_36-f";
export var disabled = "_36-6";
export var disabledSubtle = "_36-7";
export var error = "_36-8";
export var green = "_36-h";
export var grey = "_36-e";
export var icon = "_36-0";
export var inherit = "_36-b";
export var lightGrey = "_36-d";
export var orange = "_36-j";
export var pink = "_36-l";
export var primary = "_36-1";
export var purple = "_36-m";
export var quaternary = "_36-4";
export var quinary = "_36-5";
export var red = "_36-k";
export var secondary = "_36-2";
export var success = "_36-a";
export var tertiary = "_36-3";
export var warning = "_36-9";
export var white = "_36-n";
export var yellow = "_36-i";